// The running state a long request shows while the server works: the elapsed
// time, the budget when one exists, and what the server is doing when it is
// known. A request past one second with nothing on screen but a disabled
// button reads as a hang ("user can't tell that something is loading",
// 2026-09-09); a spinner without a number is the same silence.

import { useEffect, useState } from 'react';

export function RunningNotice({
  since,
  budgetSecs,
  what,
}: {
  /** `Date.now()` when the request started; null when nothing is running. */
  since: number | null;
  /** The server's time budget for this request, in seconds, when there is one. */
  budgetSecs?: number | undefined;
  /** What the server is doing, in the user's words. */
  what?: string | undefined;
}) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (since === null) return undefined;
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [since]);
  if (since === null) return null;
  const elapsed = Math.max(0, Math.floor((now - since) / 1000));
  const nearBudget = budgetSecs !== undefined && elapsed >= budgetSecs * 0.8;
  return (
    <p
      role="status"
      aria-live="polite"
      className={`text-xs tabular-nums ${nearBudget ? 'text-tres-warning' : 'text-tres-text-secondary'}`}
    >
      {what ? `${what} · ` : ''}running · {elapsed} s{budgetSecs !== undefined ? ` of ${budgetSecs} s` : ''}
    </p>
  );
}
